import { TValidatorValue } from './models';
import { validate } from './utils';

const EMPTY_MESSAGE = 'Поле обязательно для заполнения';

export const validateNotEmpty =
    (message = EMPTY_MESSAGE) =>
    (value?: TValidatorValue) =>
        validate(value, message);
